(function (app, ng) {
    renewalDialogCtrl.$inject = ["$mdDialog", "_", "eligibilityFormApi", "$window", "purchaseApi", "$interval", "agreementsApi", "$timeout"];
    app.controller("renewalDialogCtrl", renewalDialogCtrl);

    function renewalDialogCtrl($mdDialog, _, eligibilityFormApi, $window, purchaseApi, $interval, agreementsApi, $timeout) {
        var $ctrl = this;      
        ng.extend($ctrl,
            {
                UI: {
                    loadingActions: false,
                    showCompletedSection: false
                },
                addSurveyRenewalEvent: addSurveyRenewalEvent,
                closeDialog: closeDialog,
                intervals: [],
                openDeclinedModal: openDeclinedModal,
                openErrorModal: openErrorModal,
                openSignatureModal: openSignatureModal,
                setSurveyRenewalAsIgnored: setSurveyRenewalAsIgnored,
                setSurveyRenewalAsAccepted: setSurveyRenewalAsAccepted,
                setSurveyRenewalAsDeclined: setSurveyRenewalAsDeclined,
                refreshSurveyRenewalList: refreshSurveyRenewalList
            });     

        function closeDialog() {
            ng.forEach($ctrl.surveyRenewals, function (s, i) {
                if (s.SurveyRenewalStatusId === 1) {
                    setSurveyRenewalAsIgnored(s);
                }
            });

            $mdDialog.hide(false);
        }

        $ctrl.payComponentCallback = function (callback) {
           
            if (callback.result.surveyRenewalId) {
                $ctrl.UI.showPaymentSection = false;
                var renewalModel = _.find($ctrl.surveyRenewals, function (s) { return s.SurveyRenewalId === callback.result.surveyRenewalId; });   
                renewalModel.ActionTaken = false;
                
                if (callback.result.orderId) {
                   
                    renewalModel.OrderId = callback.result.orderId;

                    //set interval to poll SurveyRenewal that is awaiting payment to complete
                    var intervalPromise = $interval(function () {

                        eligibilityFormApi.getSurveyRenewalByOrderId(callback.result.orderId).then(function (orderSurvey) {

                            if (orderSurvey.OrderComplete) {
                                renewalModel.OrderComplete = true;
                                $interval.cancel(intervalPromise);
                                if (renewalModel.MarketingStrategy.DocusignApiTemplate !== null && renewalModel.MarketingStrategy.DocusignApiTemplate.RenewalDocusignDocumentId.length) {
                                    $ctrl.openSignatureModal(renewalModel);
                                }
                            }
                        }).catch(function (e) {
                            $interval.cancel(intervalPromise);
                        });
                    }, 1000);
                    /* if (callback.result.action === "Back") {                   
                    if (callback.result.action === "Order Submitted" && callback.result.orderId) {}
                    if (callback.result.action === "Order Completed") {} */
                }

            }
         
            return;
        };

        function setSurveyRenewalAsAccepted(survey) {
            if (survey.MarketingStrategy.PurchaseModel) {
                $ctrl.PurchaseModel = survey.MarketingStrategy.PurchaseModel;

                //add items to build order model in order page component
                purchaseApi.getMarketingDollars().then(function (response) {
                    $ctrl.PurchaseModel.AgentMarketingDollars = response.MarketingDollarsTotal !== null ? response.MarketingDollarsTotal : 0;

                }).catch(ng.noop);
                $ctrl.PurchaseModel.MarketingStrategyName = survey.MarketingStrategy.MarketingStrategy;
                $ctrl.PurchaseModel.ArcSurveyRenewalId = survey.SurveyRenewalId;

                $ctrl.UI.showPaymentSection = true;           
            }

            else {
                /* Need to get new docusign link and open it */
                if (survey.MarketingStrategy.DocusignApiTemplate !== null && survey.MarketingStrategy.DocusignApiTemplate.RenewalDocusignDocumentId.length) {
                    $ctrl.openSignatureModal(survey);
                }
                else {
                    var surveyRenewalStatusId = 2;
                    survey.RenewalStatus = "Accepted";
                    eligibilityFormApi.surveyRenewalAccepted(survey.SurveyRenewalId, surveyRenewalStatusId).then(function () {
                        $ctrl.refreshSurveyRenewalList();
                    });

                }
            }
            survey.ActionTaken = false;
        }

        function openDeclinedModal(survey, $event) {
            var alert = $mdDialog.confirm({
                clickOutsideToClose: true,
                //title: 'This is an alert title',
                textContent: 'Are you sure you do NOT want to renew ' + survey.Name + '?',
                ariaLabel: 'Alert Dialog',
                ok: 'Will Not Renew',
                cancel: 'Cancel',
                targetEvent: $event,
                multiple: true
            });

            $mdDialog.show(alert).then(function (response) {
                setSurveyRenewalAsDeclined(survey);
            }).catch(function () {
                survey.ActionTaken = false;
            });

        }

        function setSurveyRenewalAsDeclined(survey) {
            var surveyRenewalStatusId = 3;
            survey.RenewalStatus = "Declined";
            return eligibilityFormApi.surveyRenewalDeclined(survey.SurveyRenewalId, surveyRenewalStatusId).then(function () {
                refreshSurveyRenewalList();
                survey.ActionTaken = false;
            }).catch(function (error) {
                survey.ActionTaken = false;
            });
        }

        function setSurveyRenewalAsIgnored(survey) {
            eligibilityFormApi.surveyRenewalIgnored(survey.SurveyRenewalId).then(function () {
                $ctrl.refreshSurveyRenewalList();
            });
            survey.ActionTaken = false;
            return;
        }

        function addSurveyRenewalEvent(survey, eventText) {
            return eligibilityFormApi.createSurveyRenewalEvent(survey.SurveyRenewalId, eventText);
        }

        function pollSurveyForCompleteStatus(surveyRenewalId) {

            var intervalPromise = $interval(function () {

                eligibilityFormApi.getSurveyRenewalBySurveyRenewalId(surveyRenewalId).then(function (survey) {
                    if (survey.SurveyRenewalStatusId === 2 || survey.SurveyRenewalStatusId === 3) {
                        $ctrl.refreshSurveyRenewalList();
                        $interval.cancel(intervalPromise);
                    }
                }).catch(function (e) {
                    console.log(e);
                    $interval.cancel(intervalPromise);
                });
            }, 1000);
        }

        function openErrorModal(error, $event) {
            var alert = $mdDialog.alert({
                clickOutsideToClose: true,
                //title: 'This is an alert title',
                textContent: "We're sorry, there was an error; Please reload this page and try again.",
                ariaLabel: 'Alert Dialog',
                ok: 'Ok',
                targetEvent: $event,
                multiple: true
            });

            $mdDialog.show(alert).then(function (response) {
                console.log(response);
            }).catch(function (error) {
                console.log(error);
            });
        }

        function refreshSurveyRenewalList() {
            return eligibilityFormApi.getSurveyRenewals($ctrl.filterBySurveyId).then(function (results) {
                $ctrl.surveyRenewals = results;
                var openSurveys = _.some(results, function (s) { return s.SurveyRenewalStatusId === 1; });
                if (!openSurveys) {
                    $ctrl.UI.showCompletedSection = true;
                }
                else {
                    $ctrl.surveyRenewals = results;
                }
                return;
            }, function () {
                return null;
            });
        }

        function openSignatureModal(survey, $event) {

            agreementsApi.getSurveyAgreementRenewalDocusignLink(survey.SurveyId, survey.SurveyRenewalId).then(function (redirectUrl) {
                var modal = $mdDialog.confirm({
                    clickOutsideToClose: true,
                    //title: 'This is an alert title',
                    textContent: survey.Name + " requires you to sign a renewal agreement, would you like to sign now?",
                    ariaLabel: 'Alert Dialog',
                    ok: 'Yes',
                    cancel: 'No',
                    targetEvent: $event,
                    multiple: true
                });

                $mdDialog.show(modal).then(function (response) {
                    $ctrl.addSurveyRenewalEvent(survey, "Docusign Agreement Link Opened");
                    $window.open(redirectUrl);
                    pollSurveyForCompleteStatus(survey.SurveyRenewalId);
                    survey.ActionTaken = false;
                }).catch(function (error) {
                    console.log(error);
                    survey.ActionTaken = false;
                });
            }).catch(function (e) {
                console.log(e);
                openErrorModal(e);
                survey.ActionTaken = false;
            });
        }
    }
})(window.app, window.angular); // jshint ignore:line